<template>
  <div class="countdown-icon">
    <v-progress-circular
      color="primary"
      size="56"
      width="4"
      :value="errorCountdown * value"
      rotate="-90"
    />
    <h6 class="countdown-icon__text">{{ errorCountdown }}s</h6>
  </div>
</template>

<script>
export default {
  name: 'CountDownIcon',
  props: {
    value: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      errorCountdown: 0
    };
  },
  created() {
    this.$eventHub.$on('phoneVerificationErrorCountdownUpdate', countdown => {
      this.errorCountdown = countdown;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('phoneVerificationErrorCountdownUpdate');
  }
};
</script>

<style lang="scss" scoped>
.countdown-icon {
  position: relative;
  display: inline-block;

  &__text {
    position: absolute;
    top: 17px;
    right: 0;
    left: 0;
    text-align: center;
  }
}
</style>
